export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const END_API_CALL = "END_API_CALL";
export const RESET_API_CALL = "RESET_API_CALL";

export interface ApiStatusAction {
  type: string;
}
